import {getPageName} from './helpers/getPageName'
import {getParentLocation} from './helpers/parent'
import {createPathNameWatcher} from '../../../shared/createPathNameWatcher'

try {
  createPathNameWatcher((watcherType: 'NavigationApi' | 'MutationObserver') => {
    try {
      const pageName = getPageName(window.location.pathname)

      const parentLocation = getParentLocation()
      const parentPageName = parentLocation ? getPageName(parentLocation.pathname) : undefined

      Ya.Rum.updateErrors({page: pageName})
      Ya.Rum.setVars({'-page': pageName})

      Ya.Rum.logEventString('page_pathname_change', pageName, {
        additional: {
          url: window.location.origin + window.location.pathname,
          parentPageName: parentPageName,
          parentURL: parentLocation?.url,
          watcherType
        }
      })
    } catch (error) {
      console.error(error)
    }
  })
} catch (error) {
  console.error(error)
}
